import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular/standalone';

/**
 * Ionic route reuse with an explicit same-URL reload path for the app-header refresh control.
 * Without this, `navigateByUrl(currentUrl)` keeps the active routed component instance.
 */
@Injectable()
export class AppRouteReuseStrategy extends IonicRouteStrategy {
  private pendingSameUrlReload = false;

  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    if (this.pendingSameUrlReload) {
      return false;
    }
    return super.shouldReuseRoute(future, curr);
  }

  /** Destroy and recreate the routed component tree for the current URL. */
  async reloadCurrentUrl(router: Router): Promise<void> {
    this.pendingSameUrlReload = true;
    try {
      const url = router.url;
      await router.navigateByUrl(url, {
        replaceUrl: true,
        onSameUrlNavigation: 'reload',
      });
    } finally {
      this.pendingSameUrlReload = false;
    }
  }
}
